import { CommonModule } from '@angular/common';
import { Component, inject, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SingleCardModule } from 'src/app/layouts';
import { Router } from '@angular/router';
import { AuthService } from './shared/services';

@Component({
    selector: 'app-unauthenticated-content',
    template: `
    <app-single-card >
      @if( isLocked$ | async ; as isLocked ) {
        Dieser Benutzer ist gesperrt - bitte wenden Sie sich an den Systemadministrator.
      } @else{
        Bitte warten - Benutzer wird angemeldet...
      }
    </app-single-card>
  `,
    styles: [
        `
      :host {
        width: 100%;
        height: 100%;
      }
    `,
    ],
    standalone: false
})
export class UnauthenticatedContentComponent {

  private readonly authService =  inject(AuthService);
  public readonly isLocked$ = this.authService.isLocked$;

  
  constructor(private router: Router) {}



 
}
@NgModule({
  imports: [CommonModule, RouterModule, SingleCardModule],
  declarations: [UnauthenticatedContentComponent],
  exports: [UnauthenticatedContentComponent],
})
export class UnauthenticatedContentModule {}
